import { Flex, Skeleton } from "antd";

import { formatPriceToAR } from "../utils/utils";

import MarqueeCard from "./MarqueeCard";
import { SkeletonMarquee } from "./skeletons/home";

import { Splide, SplideSlide, SplideTrack } from "@splidejs/react-splide";
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

const carouselOptions = {
    type   : 'loop',
    drag   : 'free',
    focus  : 'center',
    autoScroll: {
        speed: 2,
    },
    arrows: false,
    perPage: 6,
    gap: "1rem",
    breakpoints: {
        375: {
            perPage: 1,
        },
        768: {
            perPage: 1,
        },
        1024: {
            perPage: 3,
        },
        1440: {
            perPage: 4,
        },
        1920: {
            perPage: 4,
        },
        2000: {
            perPage: 5,
        },
    },
};

export default function Marquee({ isLoading, content, bgColor }) {
    return (
        <div className="marquee-splide" style={{ "--bg-color": bgColor || null }}>
            {isLoading ? (
                <SkeletonMarquee />
            ) : (
                <Splide hasTrack={false} options={carouselOptions} extensions={{ AutoScroll }} className="--react --graph">
                    <SplideTrack>
                        {content?.map((card, i) => (
                            <SplideSlide key={i}>
                                <MarqueeCard
                                    key={i + content.length}
                                    label={card.indice}
                                    sublabel={card.descripcion}
                                    value={formatPriceToAR(card.precioUltimaOperacion || 0)}
                                    variation={card.variacion}
                                    logo={card.logo}
                                />
                            </SplideSlide>
                        ))}
                    </SplideTrack>
                </Splide>
            )}
        </div>
    );
}
